import * as Api from '@ViewModels';
import * as React from 'react';
import { getDisplayName } from '../../../models/NameUtils';
import { Dropdown, DropdownContent, DropdownItem, DropdownSelectTrigger } from '../../components-v2/Dropdown';
import { UserSelectModal } from '../../components/UserSelectModal';
import { styleSheet } from './styles';

export type UserFilterMode = 'all' | 'me' | 'employee';

export interface IUserFilterValue {
	mode: UserFilterMode;
	employee?: Api.UserViewModel | null;
}

export interface IUserFilterDropdownProps {
	value: IUserFilterValue;
	onChange: (value: IUserFilterValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export const UserFilterDropdown = ({ value, onChange, impersonationContext }: IUserFilterDropdownProps) => {
	const [isEmployeeModalOpen, setIsEmployeeModalOpen] = React.useState(false);

	const triggerText =
		value.mode === 'all'
			? 'Show all users'
			: value.mode === 'me'
				? 'Just Me'
				: value.employee
					? getDisplayName(value.employee)
					: 'Select an Employee';

	return (
		<>
			<Dropdown>
				<DropdownSelectTrigger styles={[styleSheet.userSelect]}>{triggerText}</DropdownSelectTrigger>
				<DropdownContent>
					<DropdownItem onClick={() => onChange({ mode: 'all' })}>Show all users</DropdownItem>
					<DropdownItem onClick={() => onChange({ mode: 'me' })}>Just Me</DropdownItem>
					<DropdownItem onClick={() => setIsEmployeeModalOpen(true)}>Select an Employee</DropdownItem>
				</DropdownContent>
			</Dropdown>
			<UserSelectModal
				impersonationContext={impersonationContext}
				modalProps={{
					isOpen: isEmployeeModalOpen,
					onRequestClose: (user?: Api.UserViewModel, cancel?: boolean) => {
						if (user && !cancel) {
							onChange({ mode: 'employee', employee: user });
						}
						setIsEmployeeModalOpen(false);
					},
				}}
				title='Select an Employee'
			/>
		</>
	);
};
